import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async () => {
  const { data } = await api.get("/products");
  return data;
};

export const fetchProduct = async (slug) => {
  const { data } = await api.get(`/products/${slug}`);
  return data;
};

export const submitInquiry = async (payload) => {
  const { data } = await api.post("/inquiries", payload);
  return data;
};

export const commissionChat = async ({ session_id, message }) => {
  const { data } = await api.post("/commission/chat", { session_id, message });
  return data;
};

export const createCheckoutSession = async ({ items, shipping_method, customer_email }) => {
  const { data } = await api.post("/checkout/create-session", {
    items,
    shipping_method,
    origin_url: window.location.origin,
    customer_email,
  });
  return data;
};

export const getCheckoutStatus = async (session_id) => {
  const { data } = await api.get(`/checkout/status/${session_id}`);
  return data;
};
